import React, { Component } from 'react';
import axios from 'axios';
import { 
  Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  TablePagination, CircularProgress, Alert, Chip, Button, TextField, InputAdornment
} from '@mui/material';
import ViewmoreQuotes from './ViewmoreQuotes';
import { NavLink } from 'react-router-dom';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import searchIcon from './images/SEARCH.png';

class ServiceQuote extends Component {
  state = {
    quotes: [],
    loading: true,
    error: '',
    page: 0, search: "",
    service: "",
    services: [],
    rowsPerPage: 5,
    totalItems: 0,
    itemsPerPageOptions: [5, 10, 20],
  
  };

  componentDidMount() {
	   document.title = "Prep for Sale- Staff Management";
		if(localStorage.getItem("DCuserid")==null)
		  {
		   this.setState({
            logredirect: true,
			pagename:'/'
          })
		  }
     this.fetchServices();
    this.fetchQuotes();
  }

  fetchServices = () => {
    axios.get(Serverurl + 'servicemanagement/servicemanagementall')
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        this.setState({ services: data });
      })
      .catch(err => console.error("Error fetching services:", err));
  };

  fetchQuotes = () => {
    const { search, service, page, rowsPerPage } = this.state;

    this.setState({ loading: true });

const params = {
  page,
  limit: rowsPerPage,
  search: this.state.search,
  service: this.state.service
};

    axios.get(Serverurl + "requestaquote/requestgetall", { params })
      .then((res) => {
        const { data, totalItems } = res.data;
        this.setState({
          quotes: data || [],
          totalItems: totalItems || 0,
          loading: false
        });
      })
      .catch((err) => {
        console.error("Error fetching quotes:", err);
        this.setState({ error: 'Failed to fetch quotes', loading: false });
      });
  };

  handleSearchChange = (e) => this.setState({ search: e.target.value });
  handleServiceChange = (e) => this.setState({ service: e.target.value });
  handleSearchClick = () => this.setState({ page: 0 }, this.fetchQuotes);
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchQuotes);
  };

  handleChangeRowsPerPage = (event) => {
    const rows = parseInt(event.target.value, 10);
    this.setState({ rowsPerPage: rows, page: 0 }, this.fetchQuotes);
  };

  render() {
   if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 

    if (this.state.loading) {
      return <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}><CircularProgress /></Box>;
    }

    return (
	  	  <div className="maincontentDiv">
        <Typography pt={2} pb={3} className="contentHeading" variant="h5" gutterBottom>Requested Quotes</Typography>

        {this.state.error && <Alert severity="error" sx={{ mb: 2 }}>{this.state.error}</Alert>}

 <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          mb: 2,
          alignItems: 'flex-end'
        }}>

          <Box className="contentSearch" sx={{ display: "flex", flexDirection: "column", width: "230px" }}>
            <Typography variant="body1">
              Name / Email / Phone
            </Typography>

            <TextField
              variant="outlined"
              size="small"
              fullWidth
              placeholder="Search"
              value={this.state.search}
              onChange={this.handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={searchIcon} alt="Search" />
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          {/* Service Dropdown */}
          <Box sx={{ display: "flex", flexDirection: "column", width: "230px" }}>
            <Typography variant="body1">Service</Typography>

            <TextField
              select
              variant="outlined"
              size="small"
              value={this.state.service}
              onChange={this.handleServiceChange}
              SelectProps={{ native: true }}
            >
              <option value="">All</option>
              {this.state.services.map((s) => (
                <option key={s.sm_id} value={s.sm_title}>
                  {s.sm_title}
                </option>
              ))}
            </TextField>
          </Box>

          {/* Search Button */}
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="contained"
              className="frmPrimarybtn"
              onClick={this.handleSearchClick}
            >
              Search
            </Button>
          </Box>
        </Box>
		
        {this.state.quotes.length === 0 ? (
          <Typography align="center">No quotes found.</Typography>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Phone</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Services</TableCell>
                
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.quotes.map((quote) => (
                  <TableRow key={quote.rq_id}>
                    <TableCell>{quote.rq_name}</TableCell>
                    <TableCell>{quote.rq_emailid}</TableCell>
                    <TableCell>{quote.rq_phoneno}</TableCell>
                    <TableCell>{quote.rq_address}</TableCell>
                    <TableCell>
                      {quote.rq_sm_id?.length > 0 ? (
                        quote.rq_sm_id.map((service) => (
                          <Chip key={service.sm_id} label={service.sm_title} size="small" sx={{ mr: 0.5, mb: 0.5 }} />
                        ))
                      ) : 'No Services'}
                    </TableCell>
                    <TableCell>
                      <NavLink to={`/ViewmoreQuotes?id=${quote.rq_id}`} style={{ textDecoration: 'none' }}>
  <Button variant="contained" size="small" className="frmPrimarybtn" >View</Button>
</NavLink>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={this.state.totalItems}
              page={this.state.page}
              onPageChange={this.handleChangePage}
              rowsPerPage={this.state.rowsPerPage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
              rowsPerPageOptions={this.state.itemsPerPageOptions}
            />
          </TableContainer>
        )}
      </div>
    );
  }
}

export default ServiceQuote;
